import React from "react";
import { Flex, Text } from "@mantine/core";
import { formatNumber } from "../../utils/numberFormatting";
import colors from "../../designTokens/colors";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "../../hooks/useIsMobile";

export const PerformanceBoxPlot = ({ boxPlotData }) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile("xl");

  return (
    <Flex
      direction={"column"}
      gap={8}
      w={"100%"}
      p={isMobile ? "16" : "24 48 24 24"}
    >
      {Object.entries(boxPlotData).map(([metric, { min, max, avg }]) => (
        <Flex key={metric} direction="column" align="center" w={"100%"} gap={0}>
          <Text
            size={isMobile ? "sm" : "md"}
            fw={500}
            c={"gray.5"}
            transform="capitalize"
          >
            {t(`common.${metric}`)}
          </Text>
          <Flex align="center" gap={8} w={"100%"}>
            <Text size={isMobile ? "sm" : "md"} w={30} ta="right">
              {formatNumber(min)}
            </Text>
            <Flex style={{ flex: 1, position: "relative" }}>
              <Flex
                style={{
                  width: "100%",
                  height: 16,
                  backgroundColor: "white",
                }}
              >
                <Flex
                  style={{
                    width: `${((max - min) / max) * 100}%`,
                    height: "100%",
                    backgroundColor: colors.gray[1],
                    marginLeft: `${(min / max) * 100}%`,
                  }}
                />
                <Flex
                  style={{
                    position: "absolute",
                    left: `${(avg / max) * 100}%`,
                    height: "100%",
                    alignItems: "center",
                  }}
                >
                  <Flex
                    style={{
                      width: 2,
                      height: "100%",
                      backgroundColor: colors.blue[5],
                    }}
                  />
                  <Text
                    size={isMobile ? "sm" : "md"}
                    style={{
                      marginLeft: 4,
                      color: colors.blue[5],
                    }}
                  >
                    {formatNumber(avg.toFixed(2))}
                  </Text>
                </Flex>
              </Flex>
            </Flex>
            <Text size={isMobile ? "sm" : "md"} w={30}>
              {formatNumber(max)}
            </Text>
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
};

export default PerformanceBoxPlot; 